module.exports = __webpack_public_path__ + "img/ahamove.1eb5e80d.png";